import { ThumbnailComponent, thumbnailTemplate } from './Thumbnail';
import styles from './Thumbnail.styles.scss';
export const thumbnailDefinition = {
    baseName: 'thumbnail',
    template: thumbnailTemplate,
    styles,
};
export const chameleonThumbnail = ThumbnailComponent.compose(thumbnailDefinition);
